import { render, staticRenderFns } from "./DoseDependentCTA.vue?vue&type=template&id=c42ec624"
import script from "./DoseDependentCTA.vue?vue&type=script&lang=js"
export * from "./DoseDependentCTA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports